import template from './insuranceApplicationsPipeline.html';
import controller from './insuranceApplicationsPipelineCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
